import * as _ from 'lodash';
import { Component, Injector } from '@angular/core';
import { FilterByComponent } from '../abstract-filter-by.component';

@Component({
    selector: 'filters-by-society',
    templateUrl: './filters-by-society.component.html',
    styleUrls: ['./filters-by-society.component.scss']
})
export class FiltersBySocietyComponent extends FilterByComponent {
    public society = '';

    private _timer: any;

    constructor(
        protected injector: Injector
    ) {
        super(injector);
        this.filterKey = 'society';
    }

    clearTimer() {
        if (this._timer) {
            clearTimeout(this._timer);
        }
    }

    onChange() {
        this.clearTimer();
        const value = this[this.filterKey];
        if (value === '') {
            const filters = this.serviceListings.filters;
            delete filters.society;
            this.serviceListings.filters = filters;
            this.isFiltersDirty.emit({ filterKey: this.filterKey, isDirty: false });
        } else {
            this.serviceListings.filters = _.extend(this.serviceListings.filters, {
                society: value
            });
            this.checkIsDirty(value, this.filterKey);
        }
        this._timer = setTimeout(this.sendFilter.bind(this), 700);
    }

    sendFilter() {
        this.serviceListings.dataStoreChanged();
        this.saveFilter();
    }

    reset() {
        this.society = '';
        const filters = this.serviceListings.filters;
        delete filters[this.filterKey];
        this.serviceListings.filters = filters;
        this.isFiltersDirty.emit({ filterKey: this.filterKey, isDirty: false });
    }
}
